<template>
  <section>
    <b-button-toolbar>
      <b-button-group size="lg">
        <b-button variant="outline-primary" @click="showApplicationList">
          {{ $t('application-list-button-toolbar.button.display.label') }}
          <b-icon icon="cart3" aria-hidden="true"></b-icon>
        </b-button>
        <b-button
          variant="success"
          @click="showApplicationListConfirmSendMessage"
        >
          {{ $t('application-list-button-toolbar.button.send.label') }}
        </b-button>
      </b-button-group>
    </b-button-toolbar>
    <application-list-confirm-send-message-modal
      :id="`application-list-confirm-send-message-${uuid}`"
      ref="application-list-confirm-send-message"
      @confirm="showApplicationList"
      @cancel="showApplicationList"
    ></application-list-confirm-send-message-modal>
    <dharma-application-form ref="application_form"></dharma-application-form>
  </section>
</template>

<script>
import Vue from 'vue'

import UUID from '@estudioliver/vue-uuid-v4'

import { ButtonGroupPlugin } from 'bootstrap-vue'
import { ButtonPlugin } from 'bootstrap-vue'
import { ButtonToolbarPlugin } from 'bootstrap-vue'
import { IconsPlugin } from 'bootstrap-vue'
import { ModalPlugin } from 'bootstrap-vue'

import ApplicationListConfirmSendMessageModal from './modals/ApplicationListConfirmSendMessageModal'
import DharmaApplicationForm from '@/components/forms/dharma-application-form/DharmaApplicationForm'
import i18n from '@/plugins/i18n.js'

Vue.use(ButtonGroupPlugin)
Vue.use(ButtonPlugin)
Vue.use(ButtonToolbarPlugin)
Vue.use(IconsPlugin)
Vue.use(ModalPlugin)
Vue.use(UUID)

export default {
  i18n,
  name: 'application-list-button-toolbar',
  data() {
    return {
      uuid: null
    }
  },
  methods: {
    showApplicationListConfirmSendMessage() {
      this.$bvModal.show(`application-list-confirm-send-message-${this.uuid}`)
    },
    showApplicationList() {
      this.$bvModal.show(`application-list-${this.$refs[`application_form`].uuid}`)
    }
  },
  created() {
    // alert(`Vue version : ${Vue.version}`)
    this.uuid = this.$uuidKey()
  },
  components: {
    ApplicationListConfirmSendMessageModal,
    DharmaApplicationForm
  }
}
</script>